// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2wNzy","validationTips":"StatementDescriptor_validationTips__2mADF"};